import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FilesUploadingProps from '../data/filesUploadingProps_old';
import * as sinisterCardsActions from '../redux/actions/sinister-cards';
import { checkIfHotjarEnable, timeBetweenDates } from '../utils/helpers';
import history from '../utils/history';
import IconCheck from '../assets/icon-check.svg';
import IconEye from '../assets/ic_eye_blue.svg';
import RimacTopBar from '../components/common/RimacTopBar/RimacTopBar';
import Navbar from '../components/common/Navbar/Navbar';
import IconDocument from '../assets/ic_drop_doc.svg';

const BeforeStartPage = () => {
  const dispatch = useDispatch();
  const sinisterList = useSelector((state) => state.sinisterCards.sinisterList);
  const isFirstSinisterSelected = sinisterList.find(
    (sinister) => sinister.code === 'COB01'
  );
  const { listFiles } = FilesUploadingProps;
  const foundCob5 = sinisterList.filter((item) => item.code === 'COB05');
  const foundCob6 = sinisterList.filter((item) => item.code === 'COB06');
  const requiredDocuments = listFiles.filter(
    (file) => file.id !== '5' && file.id !== '6'
  );
  const [viewStartTime, setViewStartTime] = useState(new Date());

  if (foundCob5.length > 0) requiredDocuments.push(listFiles[4]);
  if (foundCob6.length > 0) requiredDocuments.push(listFiles[5]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    return () => {
      const endTime = new Date();
      const userTotalTime = timeBetweenDates(viewStartTime, endTime);

      if (checkIfHotjarEnable()) {
        window.digitalData.push({
          task: {
            name: 'Tiempo registrado - Antes de comenzar',
            time: userTotalTime,
          },
          event: 'trackTimeToComplete',
        });
      }
    };
  }, []);

  const onExampleDownloadClick = (title) => {
    if (checkIfHotjarEnable()) {
      window.digitalData.push({
        action: {
          group: 'Tramites Siniestros – Protección Tarjeta BBVA',
          category: 'Para comenzar',
          name: 'Ver ejemplo',
          label: title,
        },
        event: 'trackAction',
      });
    }
  };

  const onBackHandler = () => {
    if (isFirstSinisterSelected) {
      history.replace('/otros-seguros');
      return;
    }

    history.replace('/detalle-siniestro');
  };

  const continueHandler = () => {
    dispatch(sinisterCardsActions.incrementStep());
    history.replace('/documentos-requeridos');
  };

  return (
    <>
      <RimacTopBar />
      <div
        data-testid="before-start-page"
        className="beforeStartPage pageContainer"
      >
        <div className="beforeStartPage__left pageContainer__left">
          <div className="titleCont">
            <h1 className="u-mb-24">Seguro de Protección de Tarjetas</h1>
            <p>
              Hola, sabemos que sufriste un siniestro y queremos ayudarte a
              reportarlo.
            </p>
          </div>
        </div>
        <div className="beforeStartPage__right pageContainer__right">
          <div className="titleCont">
            <h3 className="u-mb-16">¡Para comenzar!</h3>
            <p className="u-mb-40">
              Necesitas digitalizar <b>(foto o escaneado)</b> los siguientes
              documentos:
            </p>

            <ul data-testid="documents-list">
              {requiredDocuments.map((doc, i) => (
                <li className="u-mb-16 listItem" key={`doc-${i}`}>
                  <div className="listItem__left">
                    <img src={IconDocument} alt="documento a registrar" />
                  </div>
                  <div className="listItem__right">
                    <span className="left">
                      <img src={IconCheck} alt="documento a registar" />
                      <span>
                        <span>{doc.title}</span>
                        {doc.id === '2' && <p>Debes realizarla de forma presencial en la comisaría del distrito donde ocurrió el hecho.</p>}
                        {doc.id === '4' && <p>Los consumos no reconocidos deben estar procesados.</p>}
                        {doc.id === '5' && <p>Los movimientos no reconocidos deben estar procesados.</p>}
                        <a
                          className="link"
                          href={doc.docUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => onExampleDownloadClick(doc.title)}
                        >
                          <img src={IconEye} alt="descarga un ejemplo aquí" />
                          <p>Ver ejemplo</p>
                        </a>
                      </span></span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Navbar
          navActive
          onBackClick={onBackHandler}
          onContinueClick={continueHandler}
          currentStep={1}
          totalSteps={5}
          stepperText={'VOLVER'}
        />

        <div className="spacingLeft"></div>
      </div>
    </>
  );
};

export default BeforeStartPage;
